import { StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { widthPercentageToDP } from 'utils/responsiveness';

const styles = StyleSheet.create({
    container: {
        display: 'flex',
        flexDirection: 'row',
    },
    description: {
        maxWidth: widthPercentageToDP(480),
        marginTop: 16,
        lineHeight: 24,
    },
    text: {
        textAlign: 'center',
    },
    boldText: {
        fontFamily: Fonts.main.bold,
    },
    detail: {
        marginRight: 8,
    },
});

export default styles;
